/**
 * What a CSGPolygon3D sweep is asked for: the three modes, the resolved path plan, and the two
 * limits the builder applies before it starts. Part of the CSGPolygon3D port, whose derivation
 * notice is in `polygonGeometry.ts`.
 */
/**
 * A previewer must not hang a tab. Godot has no such cap, but a long curve at a small
 * `path_interval` runs to thousands of frames, so a runaway interval is a real shape
 * rather than a hypothetical one.
 */
export const MAX_PATH_EXTRUSIONS = 4096;
export const MIN_POLYGON_VERTICES = 3;
//# sourceMappingURL=polygonSweepSpec.js.map